import React from 'react';

// components
import { YesNo } from '../components/inputs';
import { FormRow } from '../components/layout';

function EmbeddedBenefits() {
  return (
    <div>
      <FormRow>
        <YesNo name="embedded_benefits" />
      </FormRow>
    </div>
  );
}

export default EmbeddedBenefits;
